import * as React from 'react';

import * as styles from './TagLayout.css';

export const TagLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['tag-layout']} data-testid="TagLayout">
      {children}
    </div>
  );
};
